import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
export default function DistrictList() {
    console.log(process.env.REACT_APP_PER_PAGE);

    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    const [viewMoreData, setviewMoreData] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [delDistrictList, setdelDistrictList] = useState('');
    const [isChecked, setisChecked] = useState(false);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [sortToggle, setSortToggle] = useState(true);
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)
    // let perPage = 2;
    // let currentPage="";
    useEffect(() => {
        const getDistrictList = async () => {
            const res = await Axios.get(`api/admin/list-district?pageNo=1&perPage=${perPage}`)
            // console.log(res)
            setItems(res.data.data.data);
            // console.log(res.data.data.data);
            // setFilterData(res.data.data.data)
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));
            setLoading(false)
            localStorage.removeItem('sort_key');
            localStorage.removeItem('sort_order');
            // setItems(posts);
        };
        getDistrictList();
    }, [perPage,]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const fetchDistrictList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if(sort_key && sort_order){
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/admin/list-district?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`)
        // console.log(res)

        await setItems(res.data.data.data);
        

        return items;
    };

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        if(searchData !== ""){

            await searchHandle(currentPage);

        }else{

            await fetchDistrictList(currentPage);
    }

        
    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((fetchDistrictList) => {
                return { ...fetchDistrictList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((fetchDistrictList) =>
            fetchDistrictList.district_id === name ? { ...fetchDistrictList, isChecked: checked } : fetchDistrictList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
    const alldelete = async (e) => {

        const status = e.target.value
        let DistrictDataLength = isChecked.length;
        let DistrictIdArray = [];
        console.log( 'vivek',DistrictDataLength);
        if (DistrictDataLength >= 0) {
            for (let i = 0; i < DistrictDataLength; i++) {
                console.log(isChecked[i]);
                if (isChecked[i].isChecked === true) {
                   let districtID = isChecked[i].district_id;
                   DistrictIdArray.push({ district_id: districtID });
                }
            }
        }

        if (isChecked) {
            const res = await Axios.post(`api/admin/update-district-status`, { district_id:DistrictIdArray, action_status: status });
            console.log(res.data.data);
            setdelDistrictList(res.data.data)
             console.log(delDistrictList);
            setNotify({
                isOpen: true,
                messsage: `District has been ${status} successfully!`,
                type: 'success',

            })
            window.location.reload(false);

        }
        else {
            alert("please Select at least one check box !");
            //console.log("hii");
        }
    }


    const searchHandle = async (currentPage) => {
        // const searchBy =  document.getElementById("search_by_id").value;
        if (searchData !== "") {
            const res = await Axios.get(`api/admin/list-district?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}`)
            //const res = await Axios.get(`api/bussiness/list-buisness?pageNo=1&perPage=${perPage}&searchData=${searchData}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data)
                setTotalPage(res.data.data.totalPage)
              setpageCount(Math.ceil(res.data.data.totalPage));
            }if(res.data.data.data.length<=0){
                setItems([])
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'error',

            })
        }

    }



    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            // alert('I am Decending')
            console.log(sortkey)
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-district?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }

    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-district?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);



            }
        }
    }
    const viewMore = async (district_id) => {
         alert('hii');
        const status = district_id;
        console.log('hii',status);
        const res = await Axios.get(`api/admin/list-district?state_id=${district_id}`)
        setviewMoreData(res.data.data.data[0])
        console.log(res.data.data.data[0]);
    }
    return (
        <>
            <div className="content-page">
                <div className="content">
                    {/* <h1>{totalPages}</h1> */}
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    {/* <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Techzoni</a></li>
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                        <li className="breadcrumb-item active">Datatable</li>
                                    </ol>
                                </div> */}
                                    <h4 className="page-title">District List</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                        <div className='col-md-6'>
<div className='business_head'>
<button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>
</div>
                            </div>
                            <div className='col-md-6'>
                            
   <div className='business_head business_head_rigt'>
   {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                    <input type="" className='search-country-list' placeholder='Search...'
                                        onChange={(e) => setsearchData(e.target.value)}
                                    />
                                    <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
   </div>
                            </div>
                            <div className="col-12">
                                <div className="tble-row table-responsive">
                                    <table id="datatable" className="table table-bordered  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th><input
                                                    type="checkbox"

                                                    name="allSelect"
                                                    checked={!items.some((DistrictList) => DistrictList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></th>

                                                <th>S.No</th>
                                                <th >District ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("district_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("district_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >District Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("district_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("district_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >State ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("state_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("state_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >District Code
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("district_code", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("district_code", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                {/* <td >Modified Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("modified_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("modified_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}
                                                <th >Added Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Date Time Stamp
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("date_time_stamp", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("date_time_stamp", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Added By

                                                </th>
                                                <th >Status
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("status", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("status", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((DistrictList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[DistrictList.district_id]}
                                                        checked={DistrictList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{DistrictList.district_id}</td>
                                                    <td>{DistrictList.district_name}</td>
                                                    <td>{DistrictList.state_id}</td>
                                                    <td>{DistrictList.district_code}</td>
                                                    <td>{DistrictList.added_date}</td>
                                                    <td>{DistrictList.date_time_stamp}</td>
                                                    <td>{DistrictList.added_by}</td>
                                                    <td>{DistrictList.status}</td>
                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        value={DistrictList.district_id}
                                                        onClick={(e) => viewMore(e.target.value)}
                                                    >
                                                        View More</button></td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">DISTRICT LIST</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>S.No:-</strong></p>
                                                                <p><strong>district_id:-{viewMoreData.district_id}</strong></p>
                                                                <p><strong>district_name:-{viewMoreData.district_name}</strong></p>
                                                                <p><strong>state_id:-{viewMoreData.state_id}</strong></p>
                                                                <p><strong>district_code:-{viewMoreData.district_code}</strong></p>
                                                                {/* <p><strong>lsat name</strong>:</p>
                                                                <p><strong>tag name</strong>:</p> */}

                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">

                                                                <p><strong>added_date:-{viewMoreData.added_date}</strong></p>
                                                                <p><strong>date_time_stamp:-{viewMoreData.date_time_stamp}</strong></p>
                                                                <p><strong>added_by:-{viewMoreData.added_by}</strong></p>
                                                                <p><strong>status:-{viewMoreData.status}</strong></p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                    <button type="button" className="btn btn-primary">Save changes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div className='slect-pg-row'>
                                        <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" className="item-page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
}
